export default {
  files: [],
}
